import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-calendar",
  "use": "svg_i-calendar-usage",
  "viewBox": "0 0 16 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 18\" id=\"svg_i-calendar\"><path d=\"M13 2h3v16H0V2h3V0h2v2h6V0h2v2zM7 5v2h2V5H7zm4 0v2h2V5h-2zM3 9v2h2V9H3zm4 0v2h2V9H7zm4 0v2h2V9h-2zm-8 4v2h2v-2H3zm4 0v2h2v-2H7z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol